/**
 * PairingScreen (SCN-612) — dark screen showing the 6-char code from the /status response.
 * `code === null` covers "just launched, first poll pending" and "paired but awaiting re-pair".
 */
export function PairingScreen({ code }: { code: string | null }) {
  return (
    <div className="fullscreen pairing">
      <div className="pairing__logo">Scanify</div>
      <p className="pairing__instruction">
        Enter this code in your store admin portal under <strong>Displays</strong> to connect this
        screen.
      </p>

      {code ? (
        <div className="pairing__code">{code}</div>
      ) : (
        <div className="pairing__code pairing__code--waiting">••••••</div>
      )}

      <p className="pairing__sub">
        {code ? 'Waiting for admin to pair…' : 'Connecting…'}
      </p>

      <div className="pairing__dots">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
